export default __webpack_public_path__ + "static/media/mars-onboarding-1.df3307b7.svg";